// src/index.js
// ─────────────────────────────────────────────────────────────────────────────
// ÖNEMLI: i18n en üstte import edilmeli — React ve App'ten ÖNCE.
// Bu sayfa yenilendiğinde i18n sistemi hazır olur, component tree
// mount edilmeden önce dil dosyaları yüklenir.
// ─────────────────────────────────────────────────────────────────────────────
import "./i18n";                          // ← EN ÜSTTE, her şeyden önce

import React    from "react";
import ReactDOM from "react-dom/client";
import App      from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
